import gql from 'graphql-tag';

export default gql`
query listFA_CustomerView_fkDebitorStatuses($languageId: Int){
    fakturaAssist{
    listFA_CustomerView_fkDebitorStatuses(languageId: $languageId) {
		id
		name
    }
    
  }
}`;
